import Vue from 'vue'
import Vuex from 'vuex'
import global from './modules/global'
import getters from './getters'
import control from './modules/control'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    global,
    control
  },
  getters
})


// WEBPACK FOOTER //
// ./src/store/index.js